import articlesConfig from '~~/configs/articles.config';
import type { TArticleType } from '~~/types/local_types';

/**
 * Check if the slug is correct and redirect if not
 * and redirect if the article type is not correct
 * @param slug
 * @param articleType
 * @param externalUrl
 */
const useCheckRedirect = async (
  slug: string,
  articleType?: TArticleType | 'biografieen' | 'tags' | 'themas' | 'opiniepanel/themas',
  externalUrl?: string,
): Promise<boolean> => {
  articleType = !articleType ? 'paginas' : articleType;

  if (articleType === 'externe-link') {
    // external url is an optional field
    if (!externalUrl || externalUrl.trim() === '') {
      const { statusCode, statusMessage } = articlesConfig[articleType as string]?.notFound || {};
      throwError(statusCode || 500, statusMessage || 'Error', statusMessage);
    }

    await navigateTo(externalUrl, {
      external: true,
      replace: true,
    });

    return false;
  }

  const { path: initialPath, query } = useRoute();

  // initialPath is where we are, path is where we should be
  let path = `/${articleType}/${slug}`;

  // remove '/paginas/' since those always live under root (or the last directory).
  if (path.includes('/paginas/')) {
    path = path.replace('/paginas/', '/');
  }

  // if mismatch, redirect (with query) !
  if (initialPath !== path) {
    await navigateTo(
      {
        path,
        query,
      },
      { redirectCode: 301, replace: true },
    );
  }

  return true;
};

export default useCheckRedirect;
